var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDetailPageLoadingMobile = function SvgDetailPageLoadingMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 360,
    height: 304,
    fill: "none",
    viewBox: "0 0 360 304"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 32,
    x: 140,
    fill: "#1A1A1A",
    rx: 16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 24,
    x: 20,
    y: 48,
    fill: "#1A1A1A",
    rx: 12
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 219,
    height: 20,
    x: 70.5,
    y: 98,
    fill: "#1A1A1A",
    rx: 10
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 12,
    x: 52,
    y: 130,
    fill: "#1A1A1A",
    rx: 6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 328,
    height: 40,
    x: 16,
    y: 168,
    fill: "#1A1A1A",
    rx: 4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 12,
    x: 20,
    y: 238,
    fill: "#1A1A1A",
    rx: 6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 12,
    x: 60,
    y: 262,
    fill: "#1A1A1A",
    rx: 6
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 12,
    x: 20,
    y: 286,
    fill: "#1A1A1A",
    rx: 6
  })));
};
export default SvgDetailPageLoadingMobile;